module.exports = __webpack_public_path__ + "img/oil_paint_large_3.804b6f94.png";